import { createFileRoute, Outlet } from '@tanstack/react-router';

/** Every page of the business. Its doors are the sidebar's Business group; What Coach knows opens from the details page. */
export const Route = createFileRoute('/_app/business')({ component: Outlet });
